export default "__VITE_ASSET__CSZnznhm__"